import React, { useState } from "react";

const ClienteForm = ({ cliente, onSave, onCancel }) => {
    const [nombre, setNombre] = useState(cliente?.nombre || "");
    const [DNI, setDNI] = useState(cliente?.DNI || "");
    const [telefono, setTelefono] = useState(cliente?.telefono || "");
    const [direccion, setDireccion] = useState(cliente?.direccion || "");

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!nombre.trim()) {
            alert("El nombre es obligatorio");
            return;
        }
        if (!DNI.trim()) {
            alert("El DNI es obligatorio");
            return;
        }
        if (!telefono.trim()) {
            alert("El teléfono es obligatorio");
            return;
        }
        if (!direccion.trim()) {
            alert("La dirección es obligatoria");
            return;
        }

        onSave({
            id: cliente?.id,
            nombre: nombre.trim(),
            DNI: DNI.trim(),
            telefono: telefono.trim(),
            direccion: direccion.trim(),
        });
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <label className="block font-semibold mb-1">Nombre</label>
                <input
                    type="text"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    className="w-full p-2 border rounded"
                    autoFocus
                />
            </div>
            <div>
                <label className="block font-semibold mb-1">DNI</label>
                <input
                    type="text"
                    value={DNI}
                    onChange={(e) => setDNI(e.target.value)}
                    className="w-full p-2 border rounded"
                />
            </div>
            <div>
                <label className="block font-semibold mb-1">Teléfono</label>
                <input
                    type="text"
                    value={telefono}
                    onChange={(e) => setTelefono(e.target.value)}
                    className="w-full p-2 border rounded"
                />
            </div>
            <div>
                <label className="block font-semibold mb-1">Dirección</label>
                <input
                    type="text"
                    value={direccion}
                    onChange={(e) => setDireccion(e.target.value)}
                    className="w-full p-2 border rounded"
                />
            </div>
            <div className="flex justify-end gap-2">
                <button
                    type="button"
                    onClick={onCancel}
                    className="px-4 py-2 rounded border border-gray-400 bg-gray-100 hover:bg-gray-200"
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    className="px-4 py-2 rounded bg-purple-600 text-white font-semibold hover:bg-purple-700"
                >
                    Guardar
                </button>
            </div>
        </form>
    );
};

export default ClienteForm
